export const ONBOARDING_TOKEN = 'ONBOARDING_TOKEN';
